import { Metadata } from '@tencent/workbench-core';
import { createInstantiationIdentifier, InstantiationFactory, DependencyResolver, SyncDescriptor } from '@tencent/containerized';

/**
 * 兼容\@tencent/containerized的内部实现
 * @internal
 */
class Container {
    constructor() {
        const instantionId = createInstantiationIdentifier(Container.workbenchInstantionId);
        this.instantion = InstantiationFactory.getInstantiation(instantionId);
    }
    adoptBy(target) {
        this.instantion.mergeTo(target);
    }
    invokable(target) {
        const designParamTypes = Metadata.getParamTypes(target);
        designParamTypes.forEach((token, index) => {
            try {
                DependencyResolver.addServiceDependencies(target, token, index);
            }
            catch (e) {
                console.warn(`[IOC] ${e.message}`);
            }
        });
    }
    get(key) {
        const instance = this.instantion.invokeFunction(accessor => accessor.get(key));
        return instance;
    }
    set(key, provider) {
        var _a;
        const serviceId = key;
        if (provider.instance) {
            this.instantion.addService(serviceId, provider.instance);
        }
        else {
            const descriptor = new SyncDescriptor((_a = provider.useClass) !== null && _a !== void 0 ? _a : provider.provide, [], provider.supportDeferInvoke, provider.overridable);
            this.instantion.addService(serviceId, descriptor);
        }
        return this;
    }
    addHook(key, hookName, callback) {
        const serviceId = key;
        this.instantion.addHook(hookName, serviceId, callback);
    }
    getServiceDependency(target) {
        const dependency = DependencyResolver.getServiceDependencies(target);
        return dependency.map(item => item.id);
    }
    getClass(key) {
        return this.instantion.getClass(key);
    }
    has(key) {
        return this.instantion.has(key);
    }
}
Container.workbenchInstantionId = 'workbenchInstantion';

export { Container };
//# sourceMappingURL=container.js.map
